// import { Dispatch } from "redux";
import { StoreAction } from "../../utils/actions";
import { WeatherAndLocationData } from "../../app/PublicPages/core/models";

export interface SetWeatherDataPayload {
  data: WeatherAndLocationData;
}

export const setWeatherDataAction = (payload: SetWeatherDataPayload) => ({
  type: StoreAction.FETCH_WEATHER_DATA,
  payload,
});
